module.exports = __webpack_public_path__ + "img/icon_logo_cn@2x.953423cd.png";